import React, { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/* Pagina di prova del calcolo «Quanto Mettere da Parte — Forfettari».
   Mostra tutti i passaggi a)-h) con i numeri. Non invia nessuna email. */

const CASI = {
  caso1: {
    nome: "Caso 1 — commerciante, gruppo 2 (40%), aliquota 15%",
    scheda: { gruppo_id: 2, anno_inizio: 2019, aliquota_startup: false, gestione: "commercianti",
      riduzione_35: false, riduzione_50: false, ante_1996: false, imposta_anno_precedente: 1200,
      contributi_percentuale_anno_precedente: 0, incassato_anno_precedenti_mesi: 45000,
      acconti_imposta_pagati_anno: 600, contributi_pagati_anno: 3435.82,
      contributi_pagati_competenza_anno_precedente: 1130 },
    incasso_mese: 5000, mese: 10, anno: 2026, oggi: "2026-11-01",
  },
  caso2: {
    nome: "Caso 2 — professionista in Gestione separata, gruppo 8 (78%), aliquota 5%, aperta a marzo 2026",
    scheda: { gruppo_id: 8, anno_inizio: 2026, mese_inizio: 3, aliquota_startup: true,
      gestione: "gestione_separata", altra_copertura: false, imposta_anno_precedente: 0,
      contributi_percentuale_anno_precedente: 0, incassato_anno_precedenti_mesi: 21000,
      acconti_imposta_pagati_anno: 0, contributi_pagati_anno: 0 },
    incasso_mese: 3000, mese: 10, anno: 2026, oggi: "2026-11-01",
  },
};

const GESTIONI = [
  ["gestione_separata", "Gestione separata INPS"],
  ["artigiani", "Artigiani"],
  ["commercianti", "Commercianti"],
  ["cassa_professionale", "Cassa professionale"],
  ["non_lo_so", "Non lo so"],
];

const eur = (v) => `${String(Math.round(v || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, ".")} €`;

const Riga = ({ k, v }) => (
  <div className="flex justify-between gap-4 py-1 border-b border-[#E8E2D5] text-sm">
    <span className="text-[#64708A]">{k}</span>
    <span className="text-[#0D1527] font-mono">{v}</span>
  </div>
);

export const QmdpTestPanel = ({ token }) => {
  const [form, setForm] = useState(CASI.caso1);
  const [res, setRes] = useState(null);
  const [cfg, setCfg] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [mail, setMail] = useState(null);
  const [esito, setEsito] = useState(null);
  const [dest, setDest] = useState("assistenza@casalisilvia.com");

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const setS = (k, v) => setForm((f) => ({ ...f, scheda: { ...f.scheda, [k]: v } }));

  const calcola = async (payload) => {
    setLoading(true); setErr(null);
    try {
      const { data } = await axios.post(`${API}/admin/qmdp/calcola-prova`, payload || form,
        { headers: { Authorization: `Bearer ${token}` } });
      setRes(data);
    } catch (e) {
      setErr(e.response?.data?.detail || "Errore nel calcolo");
    } finally { setLoading(false); }
  };

  const caricaConfig = async () => {
    const { data } = await axios.get(`${API}/admin/qmdp/config`, { headers: { Authorization: `Bearer ${token}` } });
    setCfg(data);
  };

  const anteprimaMail = async () => {
    setErr(null);
    try {
      const { data } = await axios.get(`${API}/admin/qmdp/prova-benvenuto/anteprima`,
        { headers: { Authorization: `Bearer ${token}` }, responseType: "text" });
      setMail(data);
    } catch (e) { setErr("Anteprima non disponibile"); }
  };

  const inviaProva = async () => {
    setErr(null); setEsito(null);
    try {
      const { data } = await axios.post(`${API}/admin/qmdp/prova-benvenuto`, { email: dest, nome: "Mario" },
        { headers: { Authorization: `Bearer ${token}` } });
      setEsito(`Mail di prova inviata a ${data.inviata_a}`);
    } catch (e) { setErr(e.response?.data?.detail || "Invio non riuscito"); }
  };

  const p = res?.passaggi;

  return (
    <div className="space-y-6" data-testid="qmdp-test-panel">
      <div className="bg-[#FAF8F5] border border-[#E8E2D5] rounded-lg p-6">
        <h3 className="font-heading text-xl text-[#0D1527] mb-1">QUANTO METTERE DA PARTE — PAGINA DI PROVA</h3>
        <p className="text-[#64708A] text-sm mb-5">
          Inserisci i dati di una scheda e un incasso: vedi tutti i passaggi del calcolo (a-h). Non invia nessuna email.
        </p>

        <div className="flex flex-wrap gap-3 mb-6">
          {Object.entries(CASI).map(([k, c]) => (
            <button key={k} onClick={() => { setForm(c); calcola(c); }}
              className="px-4 py-2 rounded bg-gold text-black font-bold text-xs"
              data-testid={`qmdp-${k}`}>{c.nome.split("—")[0].trim().toUpperCase()}</button>
          ))}
          <button onClick={caricaConfig} className="px-4 py-2 rounded border border-[#0D1527]/25 text-[#0D1527] text-xs font-bold"
            data-testid="qmdp-load-config">VEDI PARAMETRI (TABELLE A e B)</button>
        </div>

        <div className="grid md:grid-cols-3 gap-4 text-sm">
          <label className="block">
            <span className="text-[#64708A] text-xs">Gruppo attività (1-9)</span>
            <input type="number" min="1" max="9" value={form.scheda.gruppo_id || ""} data-testid="qmdp-gruppo"
              onChange={(e) => setS("gruppo_id", Number(e.target.value))}
              className="w-full bg-white border border-[#D9D2C5] rounded px-3 py-2 text-[#0D1527]" />
          </label>
          <label className="block">
            <span className="text-[#64708A] text-xs">Codice ATECO (se il gruppo non è indicato)</span>
            <input value={form.scheda.codice_ateco || ""} data-testid="qmdp-ateco"
              onChange={(e) => setS("codice_ateco", e.target.value)}
              className="w-full bg-white border border-[#D9D2C5] rounded px-3 py-2 text-[#0D1527]" />
          </label>
          <label className="block">
            <span className="text-[#64708A] text-xs">Dove versa i contributi</span>
            <select value={form.scheda.gestione} onChange={(e) => setS("gestione", e.target.value)}
              data-testid="qmdp-gestione"
              className="w-full bg-white border border-[#D9D2C5] rounded px-3 py-2 text-[#0D1527]">
              {GESTIONI.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
          </label>
          {[["anno_inizio", "Anno di inizio attività"], ["mese_inizio", "Mese di inizio (se apre quest'anno)"],
            ["imposta_anno_precedente", "Imposta dell'anno scorso"],
            ["contributi_percentuale_anno_precedente", "Contributi a percentuale anno scorso"],
            ["incassato_anno_precedenti_mesi", "Incassato da gennaio al mese scorso"],
            ["acconti_imposta_pagati_anno", "Acconti imposta già pagati quest'anno"],
            ["contributi_pagati_anno", "Contributi già pagati quest'anno (tutti)"],
            ["contributi_pagati_competenza_anno_precedente", "di cui riferiti all'anno prima (rata di febbraio)"]].map(([k, l]) => (
            <label className="block" key={k}>
              <span className="text-[#64708A] text-xs">{l}</span>
              <input type="number" value={form.scheda[k] ?? ""} data-testid={`qmdp-${k}`}
                onChange={(e) => setS(k, Number(e.target.value))}
                className="w-full bg-white border border-[#D9D2C5] rounded px-3 py-2 text-[#0D1527]" />
            </label>
          ))}
          <label className="block">
            <span className="text-[#64708A] text-xs">Incasso del mese</span>
            <input type="number" value={form.incasso_mese} data-testid="qmdp-incasso"
              onChange={(e) => set("incasso_mese", Number(e.target.value))}
              className="w-full bg-white border border-[#D9D2C5] rounded px-3 py-2 text-[#0D1527]" />
          </label>
          <label className="block">
            <span className="text-[#64708A] text-xs">Mese / anno dichiarato</span>
            <div className="flex gap-2">
              <input type="number" min="1" max="12" value={form.mese} data-testid="qmdp-mese"
                onChange={(e) => set("mese", Number(e.target.value))}
                className="w-1/2 bg-white border border-[#D9D2C5] rounded px-3 py-2 text-[#0D1527]" />
              <input type="number" value={form.anno} data-testid="qmdp-anno"
                onChange={(e) => set("anno", Number(e.target.value))}
                className="w-1/2 bg-white border border-[#D9D2C5] rounded px-3 py-2 text-[#0D1527]" />
            </div>
          </label>
          <label className="block">
            <span className="text-[#64708A] text-xs">Data di riferimento del calendario</span>
            <input type="date" value={form.oggi || ""} data-testid="qmdp-oggi"
              onChange={(e) => set("oggi", e.target.value)}
              className="w-full bg-white border border-[#D9D2C5] rounded px-3 py-2 text-[#0D1527]" />
          </label>
          <div className="flex flex-wrap gap-4 items-center md:col-span-3 pt-2">
            {[["aliquota_startup", "Aliquota 5%"], ["riduzione_35", "Riduzione 35%"],
              ["riduzione_50", "Riduzione 50%"], ["ante_1996", "Contributi prima del 1996"],
              ["altra_copertura", "Pensionato / altra copertura"]].map(([k, l]) => (
              <label key={k} className="flex items-center gap-2 text-[#3B4658] text-xs">
                <input type="checkbox" checked={!!form.scheda[k]} data-testid={`qmdp-${k}`}
                  onChange={(e) => setS(k, e.target.checked)} /> {l}
              </label>
            ))}
          </div>
        </div>

        <button onClick={() => calcola()} disabled={loading} data-testid="qmdp-calcola"
          className="mt-6 px-7 py-3 rounded bg-gold text-black font-bold disabled:opacity-50">
          {loading ? "CALCOLO..." : "CALCOLA"}
        </button>
        {err && <p className="text-red-400 text-sm mt-3" data-testid="qmdp-errore">{err}</p>}
      </div>

      {res && (
        <div className="bg-[#FAF8F5] border border-[#E8E2D5] rounded-lg p-6 space-y-5" data-testid="qmdp-risultato">
          <div className="bg-white border border-gold/40 rounded p-5 text-center">
            <p className="text-[#64708A] text-xs tracking-widest">QUESTO MESE METTI DA PARTE</p>
            <p className="font-heading text-4xl text-[#8A6A28] my-2" data-testid="qmdp-quota">{eur(res.quota_mese)}</p>
            <p className="text-[#3B4658] text-sm">su 100 € incassati, {res.percentuale_testo} € servono per tasse e contributi</p>
            <p className="text-[#64708A] text-xs mt-2">
              Da inizio anno {eur(res.incassato_da_inizio_anno)} · dovresti avere da parte {eur(res.dovrebbe_avere_da_parte)}
            </p>
          </div>

          <div>
            <h4 className="text-[#8A6A28] text-xs font-bold tracking-widest mb-2">a) RICAVI DELL'ANNO STIMATI</h4>
            <Riga k="Incassato da inizio anno" v={eur(p.a_ricavi_stimati.incassato_da_inizio_anno)} />
            <Riga k="Mesi trascorsi / mesi di attività" v={`${p.a_ricavi_stimati.mesi_trascorsi} / ${p.a_ricavi_stimati.mesi_anno}`} />
            <Riga k="Ricavi stimati (R)" v={eur(p.a_ricavi_stimati.ricavi_stimati)} />
          </div>
          <div>
            <h4 className="text-[#8A6A28] text-xs font-bold tracking-widest mb-2">b) REDDITO FORFETTARIO</h4>
            <Riga k="Gruppo" v={p.b_reddito_forfettario.gruppo} />
            <Riga k="Coefficiente" v={`${(p.b_reddito_forfettario.coefficiente * 100).toFixed(0)}% (${p.b_reddito_forfettario.origine_gruppo})`} />
            <Riga k="Reddito" v={eur(p.b_reddito_forfettario.reddito)} />
          </div>
          <div>
            <h4 className="text-[#8A6A28] text-xs font-bold tracking-widest mb-2">c) CONTRIBUTI DELL'ANNO</h4>
            <Riga k="Gestione" v={p.c_contributi_anno.gestione} />
            <Riga k="Contributi fissi" v={eur(p.c_contributi_anno.fissi)} />
            <Riga k="Contributi a percentuale" v={eur(p.c_contributi_anno.percentuale)} />
            <Riga k="Totale" v={eur(p.c_contributi_anno.totale)} />
          </div>
          <div>
            <h4 className="text-[#8A6A28] text-xs font-bold tracking-widest mb-2">d) IMPOSTA DELL'ANNO</h4>
            <Riga k="Contributi dedotti (per cassa)" v={`${eur(p.d_imposta_anno.contributi_dedotti)} — pagati ${eur(p.d_imposta_anno.di_cui_gia_pagati)} + in scadenza ${eur(p.d_imposta_anno.di_cui_in_scadenza)}`} />
            <Riga k="Imponibile" v={eur(p.d_imposta_anno.imponibile)} />
            <Riga k="Aliquota" v={`${(p.d_imposta_anno.aliquota * 100).toFixed(0)}%`} />
            <Riga k="Imposta" v={eur(p.d_imposta_anno.imposta)} />
          </div>
          <div>
            <h4 className="text-[#8A6A28] text-xs font-bold tracking-widest mb-2">e) PERCENTUALE E QUOTA DEL MESE</h4>
            <Riga k="Percentuale" v={`${(p.e_percentuale.percentuale * 100).toFixed(2)}%`} />
            <Riga k="Incasso del mese" v={eur(p.e_percentuale.incasso_mese)} />
            <Riga k="Quota del mese" v={eur(p.e_percentuale.quota_mese)} />
          </div>
          <div>
            <h4 className="text-[#8A6A28] text-xs font-bold tracking-widest mb-2">f) CALENDARIO DEI PROSSIMI 12 MESI</h4>
            <table className="w-full text-sm" data-testid="qmdp-calendario">
              <tbody>
                {res.calendario.map((v, i) => (
                  <tr key={i} className="border-b border-[#E8E2D5]">
                    <td className="py-1.5 text-[#64708A] font-mono text-xs">{new Date(v.data).toLocaleDateString("it-IT")}</td>
                    <td className="py-1.5 text-[#0D1527]">{v.descrizione}</td>
                    <td className="py-1.5 text-right text-[#8A6A28] font-mono">{v.credito ? `a credito ${eur(v.credito)}` : eur(v.importo)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div>
            <h4 className="text-[#8A6A28] text-xs font-bold tracking-widest mb-2">g) QUANTO DOVREBBE AVERE DA PARTE</h4>
            <Riga k="Quote dei mesi" v={eur(p.g_da_parte.quote_dei_mesi)} />
            <Riga k="− acconti imposta già pagati" v={eur(p.g_da_parte.acconti_imposta_pagati)} />
            <Riga k="− contributi pagati di competenza dell'anno" v={eur(p.g_da_parte.contributi_pagati_di_competenza)} />
            <Riga k="Dovrebbe avere da parte" v={eur(p.g_da_parte.dovrebbe_avere_da_parte)} />
          </div>
          <div>
            <h4 className="text-[#8A6A28] text-xs font-bold tracking-widest mb-2">h) CONTROLLO DI CASSA</h4>
            <Riga k="Prossima scadenza" v={p.h_controllo_cassa.prossima_scadenza ? new Date(p.h_controllo_cassa.prossima_scadenza).toLocaleDateString("it-IT") : "—"} />
            <Riga k="Dovuto entro quella data" v={eur(p.h_controllo_cassa.dovuto_entro)} />
            <Riga k="Disponibile stimato" v={eur(p.h_controllo_cassa.disponibile_stimato)} />
            <Riga k="Aggiunta alla quota del mese" v={p.h_controllo_cassa.necessario ? eur(p.h_controllo_cassa.aggiunta) : "non necessaria"} />
            {p.h_controllo_cassa.messaggio && <p className="text-[#3B4658] text-xs mt-2">{p.h_controllo_cassa.messaggio}</p>}
          </div>
          {res.scheda_da_completare && (
            <div className="bg-[#FFF6E0] border border-[#E2C275] rounded p-4" data-testid="qmdp-da-completare">
              <h4 className="text-[#8A6A28] text-xs font-bold tracking-widest mb-2">SCHEDA DA COMPLETARE (segnalata allo studio)</h4>
              {res.motivi_da_completare.map((m, i) => <p key={i} className="text-[#3B4658] text-sm">· {m}</p>)}
            </div>
          )}
          {res.avvisi?.length > 0 && (
            <div className="bg-[#FFF6E0] border border-[#E2C275] rounded p-4" data-testid="qmdp-avvisi">
              <h4 className="text-[#8A6A28] text-xs font-bold tracking-widest mb-2">AVVISI NEL MESSAGGIO</h4>
              {res.avvisi.map((a, i) => <p key={i} className="text-[#3B4658] text-sm">· {a}</p>)}
            </div>
          )}
        </div>
      )}

      <div className="bg-[#FAF8F5] border border-[#E8E2D5] rounded-lg p-6" data-testid="qmdp-benvenuto">
        <h4 className="font-heading text-lg text-[#0D1527] mb-1">MAIL DI BENVENUTO [PROVA]</h4>
        <p className="text-[#64708A] text-sm mb-4">
          Contiene le condizioni generali integrali e il modulo di recesso, uguali alla pagina{" "}
          <a className="text-[#8A6A28] underline" href="/strumenti/quanto-mettere-da-parte/condizioni" target="_blank" rel="noreferrer">
            /strumenti/quanto-mettere-da-parte/condizioni
          </a>.
        </p>
        <div className="flex flex-wrap items-end gap-3">
          <button onClick={anteprimaMail} className="px-4 py-2 rounded bg-gold text-black font-bold text-xs"
            data-testid="qmdp-anteprima-mail">VEDI L'ANTEPRIMA</button>
          <label className="block">
            <span className="text-[#64708A] text-xs">Invia la prova a</span>
            <input value={dest} onChange={(e) => setDest(e.target.value)} data-testid="qmdp-dest"
              className="w-72 bg-white border border-[#D9D2C5] rounded px-3 py-2 text-[#0D1527] text-sm" />
          </label>
          <button onClick={inviaProva} className="px-4 py-2 rounded border border-[#0D1527]/25 text-[#0D1527] text-xs font-bold"
            data-testid="qmdp-invia-prova">INVIA LA PROVA</button>
        </div>
        {esito && <p className="text-[#2F6B3C] text-sm mt-3" data-testid="qmdp-esito-mail">{esito}</p>}
        {mail && (
          <iframe title="anteprima mail di benvenuto" srcDoc={mail} data-testid="qmdp-mail-iframe"
            className="w-full h-[600px] mt-4 bg-white border border-[#E8E2D5] rounded" />
        )}
      </div>

      {cfg && (        <div className="bg-[#FAF8F5] border border-[#E8E2D5] rounded-lg p-6" data-testid="qmdp-config">
          <h4 className="font-heading text-lg text-[#0D1527] mb-3">PARAMETRI IN USO {cfg.personalizzata ? "(modificati da /admin)" : "(valori di partenza)"}</h4>
          <h5 className="text-[#8A6A28] text-xs font-bold tracking-widest mb-2">TABELLA A — GRUPPI E COEFFICIENTI</h5>
          {cfg.tabella_a.map((g) => (
            <Riga key={g.id} k={`${g.id}. ${g.nome}`} v={`${(g.coeff * 100).toFixed(0)}%`} />
          ))}
          <h5 className="text-[#8A6A28] text-xs font-bold tracking-widest mt-5 mb-2">TABELLA B — PARAMETRI {cfg.tabella_b.anno}</h5>
          <pre className="text-[#3B4658] text-xs overflow-auto max-h-96 bg-white border border-[#E8E2D5] p-3 rounded">
            {JSON.stringify(cfg.tabella_b, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};
